import { VisitorEvent } from './../../../shared/models/visitor.event';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'ig-multi-event-times',
  templateUrl: './multi.event.times.component.html',
  styleUrls: ['./multi.event.times.component.scss'],
})
export class MultiEventTimesComponent implements OnInit, AfterContentInit {
  @Input() event: VisitorEvent;

  isNeedScroll = false;
  stepPx = 30;
  timeMousemoveInterval = null;
  scrollBarWidth = 0;
  @ViewChild('timewrap', { static: false }) public timeWrap: ElementRef;
  @ViewChild('fakeScrollBar', { static: false })
  public fakeScrollBar: ElementRef;

  listener: () => void = null;
  constructor(public render: Renderer2) {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.render.listen(this.timeWrap.nativeElement, 'scroll', () => {
        this.scrolling(this.timeWrap.nativeElement.scrollLeft);
      });
    });
  }

  ngOnInit(): void {
    this.getIsNeedScroll();
    this.getScrollbarWidth();
  }

  public scrollLeft() {
    this.clearTimeMousemoveInterval();
    this.timeMousemoveInterval = setInterval(() => {
      this.timeWrap.nativeElement.scrollBy(this.stepPx * -1, 0);
    }, 23);
  }

  public scrollRight() {
    this.clearTimeMousemoveInterval();
    this.timeMousemoveInterval = setInterval(() => {
      this.timeWrap.nativeElement.scrollBy(this.stepPx, 0);
      this.scrolling(this.timeWrap.nativeElement.scrollLeft);
    }, 23);
  }

  public clearTimeMousemoveInterval() {
    clearInterval(this.timeMousemoveInterval);
  }

  public get isAtStart() {
    if (!this.timeWrap) return true;
    const { scrollLeft } = this.timeWrap.nativeElement;
    return scrollLeft === 0;
  }

  public get isAtEnd() {
    if (!this.timeWrap) return false;
    const { scrollWidth, scrollLeft, clientWidth } =
      this.timeWrap.nativeElement;

    return scrollWidth - (scrollLeft + clientWidth) <= 10;
  }

  public scrollToStart() {
    if (this.timeWrap) {
      this.timeWrap.nativeElement.scroll(0, 0);
    }
  }

  public getScrollbarWidth() {
    setTimeout(() => {
      if (!this.timeWrap) return;
      const { scrollWidth, clientWidth } = this.timeWrap.nativeElement;
      const width = (clientWidth * clientWidth) / scrollWidth;
      this.scrollBarWidth = width;
    });
  }

  public scrolling(scrollLeft: number) {
    if (this.fakeScrollBar) {
      const { scrollWidth, clientWidth } = this.timeWrap.nativeElement;
      const move = (clientWidth * scrollLeft) / scrollWidth;
      this.fakeScrollBar.nativeElement.style.left = move + 'px';
    }
  }

  @HostListener('window:resize')
  public getIsNeedScroll(): void {
    setTimeout(() => {
      if (this.timeWrap) {
        let scrollWidth = this.timeWrap.nativeElement.scrollWidth;
        let clientWidth = this.timeWrap.nativeElement.clientWidth;

        this.isNeedScroll = scrollWidth > clientWidth;
      }
    });
  }
}
